import script from "./AccountPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPayment.vue?vue&type=script&setup=true&lang=js"

import "./AccountPayment.vue?vue&type=style&index=0&id=16c0b473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c0b473"]])

export default __exports__